import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            id: 0,
            number: '',
            description: '',
            subjectMatter: '',
            warrantyDays: null,
            warrantyValidityTerm: {
                start: null,
                finish: null,
            },
            validityTerm: {
                start: null,
                finish: null,
            },
            unit: { id: null },
            unitCost: '',
            hiredAmount: null,
            isInUse: false,
            isActive: true,
            items: [this.item.build()],
            office: { id: null },
            newId: 0,
            newContractItems: {},
            itemsOldToNew: [],
            demandStates: [],
            estimatedTime: null,
            executedTime: null,
        };
    },

    toForm(obj) {
        const form = utilities.toForm(obj, this.build());
        form.unitCost = form.unitCost.toString().replace('.', ',');
        return form;
    },

    toPayload(obj) {
        const payload = utilities.toPayload(obj);
        // payload.office = { id: 1 };
        payload.unitCost = payload.unitCost.toString().replace(',', '.');
        return payload;
    },

    item: {
        build() {
            return {
                id: null,
                description: null,
                timeAmount: null,
                estimatedTime: null,
                executedTime: null,
                uuid: utilities.uuidv4(),
            };
        },
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/Contract.js